import Commons from '../../../../Services/Common/Common';

export const M_TBM_CUSTOM_Schema = {
  mapper: {
    search1: {
      UserId: (context) => context.userInfo?.userid,
      TbmYn: (context) => Commons.EncryptAES(context.userInfo?.tbmYn),
    },
    search2: {
      TbmCd: (context) => Commons.EncryptAES(context.tbmCd),
    },
  },
};
